<template>
  <div class="header">
    <div class="w1202 header-wrapper">
      <div class="nav-box">
        <div class="nav-logo">
          <figure class="logo"></figure>
          <span>{{ props.navTitle }}</span>
        </div>
        <ul class="nav-list">
          <li v-for="item in navListData" @click="toPersonalCenter(item)" :key="item.id">
            <a v-if="item.target" :href="item.to" target="_blank">{{ item.name }}</a>
            <router-link v-else :to="item.to">{{ item.name }}</router-link>
          </li>
        </ul>
      </div>
      <div class="login-box">
        <div v-if="!isLogin" @click="needWhichOne(true)" class="login">
          <svg-icon name="Not-LoginAvatar" size="24px"></svg-icon>
          <span>立即登录</span>
        </div>
        <el-dropdown v-else :teleported="false" placement="top-start">
          <span class="el-dropdown-link">
            <div class="was-login">
              <img class="avatar" :src="setUserAvatars(userInfo.avatar || '1').src" alt="" />
              <span class="name">{{ userInfo.user_name || userInfo.account }}</span>
            </div>
          </span>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item>
                <router-link to="/personal">个人中心</router-link>
              </el-dropdown-item>
              <el-dropdown-item class="line"></el-dropdown-item>
              <el-dropdown-item @click="outLogin">
                <span>退出登录</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
    </div>
  </div>
  <Login
    v-if="needLoginOrReg"
    v-model:needToLoginOrReg="needLoginOrReg"
    :forgetPwdToWhere="'/user/dealRpstone'"
  ></Login>
</template>

<script setup>
import Login from '@/components/cad/Login.vue'
import { setUserAvatars } from '@/assets/js/globalfun'
import { useMapState } from '@/assets/js/use_storemap'
import { ref, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'

/* --- 全局变量 --- */
// vuex
const store = useStore()
const { isLogin, linkURL1, userInfo } = useMapState({
  isLogin: state => state.isLogin,
  linkURL1: state => state.realm.linkURL1,
  userInfo: state => state.userInfo.user_info
})

// router
const router = useRouter()
const route = useRoute()
const nowRouter = router.currentRoute.value.name

const props = defineProps({
  navTitle: {
    type: String,
    default: '迷你CAD会员'
  }
})

const needLoginOrReg = ref(false) // 是否需要登录 || 注册
const isPersonal = ref(false) // 是否属于 personal 中的页面
const navListData = ref([
  { id: 1, name: '首页', to: linkURL1.value, target: true },
  { id: 2, name: '私有云SDK', to: linkURL1.value + '/privatecloudsdk.html', target: true },
  { id: 3, name: '企业版', to: '/company', target: true },
  { id: 4, name: '会员', to: '/cad/index', target: false },
  { id: 5, name: '个人中心', to: '/personal', target: false }
])

/* --- 函数方法 --- */
if (nowRouter.split('_')[0] === 'personal') isPersonal.value = true

function needWhichOne(jump) {
  needLoginOrReg.value = true

  if (jump) {
    router.push({
      path: route.path
    })
  }
}

const toPersonalCenter = params => {
  if (params.id == 5 && !isLogin.value) {
    store.state.cad.login.show = true
    store.state.cad.login.type = 'byaccount'
  }
}

// 退出登录
async function outLogin() {
  store.commit('setIsLogin', false)
  store.commit('setUserInfo', '')
  store.commit('user/setClearAll')
  await router.push({ path: '/cad' })
}

watch(
  () => store.state.cad.login.show,
  newVal => {
    if (newVal) {
      needWhichOne()
    }
  },
  { immediate: true }
)
</script>

<style lang="scss" scoped>
@import '@/assets/scss/common.scss';
@import '@/assets/scss/_make.scss';

.header {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 99;
  line-height: 1.5;
  font-family: 'SourceHanSansCN';
  font-weight: 400;
  background: #fff;

  @include responsive-style(
    (
      height: 60px,
      box-shadow: 0px 2px 8px 0px rgba(120, 178, 225, 0.15)
    )
  );

  .header-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 100%;
    color: #171717;

    .nav-box {
      display: flex;
      align-items: center;
      height: 100%;
    }

    .nav-logo {
      display: flex;
      align-items: center;
      font-weight: 700;

      @include responsive-style(
        (
          margin-right: 65px,
          font-size: 20px
        )
      );
    }

    .nav-list {
      display: flex;
      height: 100%;

      li {
        height: 100%;
      }

      a {
        display: flex;
        align-items: center;
        height: 100%;
        color: #171717;
        @include responsive-style(
          (
            margin-right: 20px,
            padding-right: 28px,
            font-size: 16px
          )
        );

        &:hover {
          color: $--themecolor;
        }

        &.router-link-active {
          color: $--themecolor;
        }
      }
    }

    .login-box {
      height: 100%;
      user-select: none;
    }

    .login {
      display: flex;
      align-items: center;
      height: 100%;
      cursor: pointer;

      .svg-icon {
        @include responsive-style(
          (
            width: 24px,
            height: 24px
          )
        );
      }

      span {
        color: $--themecolor;
        @include responsive-style(
          (
            margin-left: 6px
          )
        );
      }
    }

    :deep(.el-dropdown) {
      height: 100%;

      .was-login {
        display: flex;
        align-items: center;
        height: 100%;
        cursor: default;

        .avatar {
          @include responsive-style(
            (
              width: 32px,
              height: 32px
            )
          );
        }

        .name {
          height: 100%;
          line-height: 4.2;
          @include whiteNoWrap();

          @include responsive-style(
            (
              width: 120px,
              margin-left: 6px,
              font-size: 14px
            )
          );
        }
      }

      .el-popper {
        background: #fff;

        @include responsive-style(
          (
            width: 200px,
            padding: 8px 10px,
            border-radius: 8px,
            box-shadow: 0px 10px 20px 0px rgba(0, 64, 119, 0.1),
            margin-top: (
              (-12px unquote('!important'))
            )
          )
        );

        .el-popper__arrow::before {
          display: none;
        }

        .el-dropdown-menu {
          padding: 0;
        }

        .el-dropdown-menu__item {
          padding: 0;
          @include responsive-style(
            (
              line-height: 22px
            )
          );

          &.line {
            width: 100%;
            background-color: #e1e1e1;
            @include responsive-style(
              (
                height: 1px,
                margin: 4px 0
              )
            );
          }

          &:not(.is-disabled):focus,
          &:hover {
            background-color: rgba(49, 50, 51, 0.07);
            @include responsive-style(
              (
                border-radius: 6px
              )
            );
          }

          a,
          span {
            display: block;
            width: 100%;
            height: 100%;
            color: #302e38;

            @include responsive-style(
              (
                padding: 9px 20px,
                font-size: 16px
              )
            );
          }
        }
      }
    }
  }

  figure.logo {
    @include responsive-style(
      (
        margin-right: 7px
      )
    );
    @include make-backgroundimage-custom(
      lg,
      (
        name: '@/assets/img/cad/logo',
        extname: 'png',
        width: 60,
        height: 60
      )
    );
    @include make-backgroundimage-custom(
      xl,
      (
        name: '@/assets/img/cad/logo-xl',
        extname: 'png',
        width: 72,
        height: 72
      )
    );
    @include make-backgroundimage-custom(
      mx,
      (
        name: '@/assets/img/cad/logo-mx',
        extname: 'png',
        width: 120,
        height: 120
      )
    );
  }
}
</style>
